/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    array, bool, func, object,
} from 'prop-types';

import PLARecsContainer from './PLARecsContainer';
import PLARecentlyViewedLayerContainer from './PLARecentlyViewedLayerContainer';
import noop from '../../../../../helpers/noop';

export default function PLARecsTypeParser({
    product, skuData, isPlaRedesignEnabled, cmsRecBlockData, campaignTrackClickThrough,
}) {
    const moduleType = cmsRecBlockData?.show_module || '';

    // 6810; this parses query type from recommendations block field of standard_product content-type. although each current use case uses same query container, this structure allows easier changes in the future.
    switch (moduleType) {
        // 6810; keeping previous flow for this recs feature
        // case 'similar products':
        //     return (
        //         <PLARecsContainer
        //             product={product}
        //             skuData={skuData}
        //             isPlaRedesignEnabled={isPlaRedesignEnabled}
        //             cmsRecBlockData={cmsRecBlockData}
        //         />
        //     );
        case 'customers also viewed':
            return (
                <PLARecsContainer
                    product={product}
                    skuData={skuData}
                    isPlaRedesignEnabled={isPlaRedesignEnabled}
                    cmsRecBlockData={cmsRecBlockData}
                    campaignTrackClickThrough={campaignTrackClickThrough}
                />
            );
        case 'more category gifts':
            return (
                <PLARecsContainer
                    product={product}
                    skuData={skuData}
                    isPlaRedesignEnabled={isPlaRedesignEnabled}
                    cmsRecBlockData={cmsRecBlockData}
                    isCategoryBased
                    campaignTrackClickThrough={campaignTrackClickThrough}
                />
            );
        case 'recently viewed':
            return (
                <PLARecentlyViewedLayerContainer
                    product={product}
                    skuData={skuData}
                    isPlaRedesignEnabled={isPlaRedesignEnabled}
                    cmsRecBlockData={cmsRecBlockData}
                    campaignTrackClickThrough={campaignTrackClickThrough}
                />
            );
        default:
            return null;
    }
}

PLARecsTypeParser.propTypes = {
    product: object.isRequired,
    skuData: array.isRequired,
    isPlaRedesignEnabled: bool.isRequired,
    cmsRecBlockData: object,
    campaignTrackClickThrough: func,
};

PLARecsTypeParser.defaultProps = {
    cmsRecBlockData: {},
    campaignTrackClickThrough: noop,
};
